function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { LAST_ACCOUNT_SLUG } from "constants/cookies";
import * as Sentry from "@sentry/nextjs";
import { filterByPositionType } from "components/pages/careers/careers-service";
const getPositions = function() {
    var _ref = _async_to_generator(function*(query, req = null, res = null) {
        try {
            const { positionsType: rawPositionsType } = query;
            const positionsType = rawPositionsType || 'external';
            let isMondayEmployee = false;
            if (req && res) {
                try {
                    const { getCookie } = require("cookies-next");
                    const lastLoginAccount = getCookie(LAST_ACCOUNT_SLUG, {
                        req,
                        res
                    });
                    isMondayEmployee = lastLoginAccount === 'monday';
                } catch (error) {
                // Cookie reading failed, isMondayEmployee remains false
                }
            }
            const { fetchAllPositions } = require("../../../../../server/services/careers-positions-service/careers-positions-service");
            const allPositions = yield fetchAllPositions(req);
            return filterByPositionType(allPositions, positionsType, isMondayEmployee);
        } catch (e) {
            Sentry.captureException(e);
            return [];
        }
    });
    return function getPositions(query) {
        return _ref.apply(this, arguments);
    };
}();
const getTeammeApiKey = function() {
    var _ref = _async_to_generator(function*() {
        try {
            const { get } = require("../../../../../secrets-service");
            const { api_key } = yield get("teamme");
            return api_key;
        } catch (e) {
            Sentry.captureException(e);
            return null;
        }
    });
    return function getTeammeApiKey() {
        return _ref.apply(this, arguments);
    };
}();
export default [
    {
        propsPropertyName: "positions",
        shouldFetch: ()=>false,
        fetch: function() {
            var _ref = _async_to_generator(function*({ query, req, res }) {
                return yield getPositions(query, req, res);
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()
    },
    {
        propsPropertyName: "teammeApiKey",
        shouldFetch: ()=>false,
        fetch: /*#__PURE__*/ _async_to_generator(function*() {
            return yield getTeammeApiKey();
        })
    }
];
